export enum EServiceChangeRequestType {
  NEW_SERVICE = 'NEW_SERVICE',
  SERVICE_UPDATE = 'SERVICE_UPDATE',
  _UNKNOWN_ = '_UNKNOWN_',
}
